import { getCompany } from "../../helpers/commonFunctions";
import axiosInstance from "../../utils/axiosCompany";

export const CreateOutlet = async (values) => {
    return await axiosInstance().post("company/save-outlet-management", values);
}

export const GetOutletList = async (values) => {
    return await axiosInstance().post("company/list-outlet-management", values);
}
export const GetOutletAllList = async (company_id) => {
    return await axiosInstance().get(`company/get-active-outlets-list?company_id=${company_id}`);
};
export const GetBrandOutletsList = async (values) => {
    return await axiosInstance().post(`company/get-brand-outlets-list`, values);
};

export const GetEditOutlet  = async (values) => {
    return await axiosInstance().post("company/edit-outlet-management", values);
}
export const GetChangeStatus = async (values) => {
    return await axiosInstance().post("company/change-status-outlet-management", values)
}
export const GetDeleteOutlet = async (values) => {
    return await axiosInstance().post("company/delete-outlet-management", values)
}
export const GetOutletDetail = async (id) => {
    return await axiosInstance().get(`company/get-edit-outlet-management?id=${id}`);
};
export const DeleteHardwareDevice = async (values) => {
    return await axiosInstance().post("company/delete-hardware-device", values)
}

export const ResendKitchenCredential = async (values) => {
    return await axiosInstance().post("company/resend-kitchen-credential", values);
}

export const GetZatcaDetails = async (values) => {
    return await axiosInstance().post("company/get-outlet-zatca-details",values);
};
export const registerToZatcaAgain = async (values) => {
    return await axiosInstance().post("company/register-to-zatca-again-request",values);
};
export const GetZatcaConfigurationsList = async (values) => {
    return await axiosInstance().post("company/get-zatca-configurations-list", values);
};
export const AddZatcaRegistration = async (values) => {
    return await axiosInstance().post("company/add-zatca-configuration", values);
};

export const lastBusinessDate = async (values) => {
    return await axiosInstance().post("company/get-outlet-last-business-date",values);
};
export const resetOutletBusinessDate = async (values) => {
    return await axiosInstance().post("company/reset-outlet-business-date",values);
};